const BASE_URL = process.env.NEXT_PUBLIC_AWS_API_GATEWAY_BASE_URL;

export interface CheckEmailResult {
  exists: boolean;
  uuid?: string;
  partnerUuid?: string;
  userType?: string;
}

interface PreferenceItem {
  id: number;
  name: string;
}

interface CheckEmailPreferences {
  countries?: PreferenceItem[];
  studyLevels?: PreferenceItem[];
  studyAreas?: PreferenceItem[];
}

export async function checkEmail(
  email: string,
  preferences?: CheckEmailPreferences,
  partnerUuid?: string,
): Promise<CheckEmailResult> {
  // Defense-in-depth: even if a caller passes an object with all-empty arrays, drop it.
  // Sending empty arrays causes the BE to overwrite stored prefs with `[]`.
  const hasRealPrefs = Boolean(
    preferences && (
      (preferences.countries?.length || 0) > 0 ||
      (preferences.studyLevels?.length || 0) > 0 ||
      (preferences.studyAreas?.length || 0) > 0
    )
  );
  // partnerUuid is optional on the BE schema; when SO knows it (from b2c_prefs),
  // forward it so BE can recover routing for Frappe-only leads that lack parent_partner_details.
  const res = await fetch(`${BASE_URL}/b2c/check-email`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email,
      ...(partnerUuid ? { partnerUuid } : {}),
      ...(hasRealPrefs ? { preferences } : {}),
    }),
  });
  if (!res.ok) throw new Error('Failed to check email');
  const json = await res.json();
  return json.data as CheckEmailResult;
}
